import "@/App.css";
import { useState, useEffect } from "react";
import { ComprehensiveCalculator } from "@/assets/calculators/comprehensive/comprehensiveCalculator";

type AppProps = {
	rootElement: HTMLElement;
};

export default function App({ rootElement }: AppProps) {
	const [calculatorType, setCalculatorType] = useState(
		rootElement?.getAttribute("calculatorType") ?? ""
	);

	useEffect(() => {
		setCalculatorType(rootElement?.getAttribute("calculatorType") ?? "Business");
	}, [rootElement]);

	const renderComponent = () => {
		if (["business", "personal"].includes(calculatorType.toLowerCase())) {
			return <ComprehensiveCalculator rootElement={rootElement} />;
		}
	};

	return renderComponent();
}
